class SOppPoint {
  constructor(x, y) {
      this.x = x;
      this.y = y;
  }
}

class SOppColorArea {
  constructor(sR, sG, sB) {
      this.sR = sR;
      this.sG = sG;
      this.sB = sB;
  }
}

class SOppWeight {
  constructor() {
      this.p1 = 0;
      this.p2 = 0;
      this.p3 = 0;
  }
}

class SOppAreaPoint {
  constructor(p1, p2, p3) {
      this.p1 = p1;
      this.p2 = p2;
      this.p3 = p3;
  }
}

function utilWeightCalc(area, point, weight) {
  const { x: sx1, y: sy1 } = area.p1;
  const { x: sx2, y: sy2 } = area.p2;
  const { x: sx3, y: sy3 } = area.p3;
  const x = point.x;
  const y = point.y;
  let m, n, p1, p2, p3, px, py;

  if (sx1 === sx3) {
      return 1;
  }
  m = (sy1 - sy3) * (x - sx3) / (sx1 - sx3) + sy3;
  n = sy2 - sy3 - (sy1 - sy3) * (sx2 - sx3) / (sx1 - sx3);
  if (n === 0) {
      return 2;
  }
  p2 = (y - m) / n;
  p1 = (x - sx3) / (sx1 - sx3) - (sx2 - sx3) / (sx1 - sx3) * p2;
  p3 = 1 - p1 - p2;

  weight.p1 = p1;
  weight.p2 = p2;
  weight.p3 = p3;
  return 0;
}

function utilAreaConvertCalc(area, weight, point) {
  const { x: sx1, y: sy1 } = area.p1;
  const { x: sx2, y: sy2 } = area.p2;
  const { x: sx3, y: sy3 } = area.p3;
  const p1 = weight.p1;
  const p2 = weight.p2;
  const p3 = weight.p3;

  point.x = p1 * sx1 + p2 * sx2 + p3 * sx3;
  point.y = p1 * sy1 + p2 * sy2 + p3 * sy3;
  return 0;
}

/**
* Color area conversion
* @param {SOppArea} srcArea - Source color area, e.g. sRGB color space
* @param {SOppArea} dstArea - Destination color area, e.g. SDL1.1 color space
* @param {SOppPoint} anchorPoint - Anchor point color coordinate, e.g. sRGB white
* @param {SOppPoint} srcPoint - Source color coordinate
* @param {SOppPoint} dstPoint - Destination color coordinate
* @returns {boolean} - True if successful, false otherwise
*/
function oppColorAreaConvert(srcArea, dstArea, anchorPoint, srcPoint, dstPoint) {
  const srcs = [
      new SOppAreaPoint(anchorPoint, srcArea.sR, srcArea.sG),
      new SOppAreaPoint(anchorPoint, srcArea.sR, srcArea.sB),
      new SOppAreaPoint(anchorPoint, srcArea.sG, srcArea.sB),
  ];
  const dsts = [
      new SOppAreaPoint(anchorPoint, dstArea.sR, dstArea.sG),
      new SOppAreaPoint(anchorPoint, dstArea.sR, dstArea.sB),
      new SOppAreaPoint(anchorPoint, dstArea.sG, dstArea.sB),
  ];
  const sWeight = new SOppWeight();

  for (let i = 0; i < 3; i++) {
      const err = utilWeightCalc(srcs[i], srcPoint, sWeight);
      if (err !== 0) {
          return err;
      } else if (sWeight.p2 >= 0 && sWeight.p3 >= 0) {
          utilAreaConvertCalc(dsts[i], sWeight, dstPoint);
          return 0;
      }
  }
  return 2;
}



export const transRgbToCxCyV2 = (
  cx,
  cy,
  dstArea = {
      sR: { x: 0.6491, y: 0.3470 },
      sG: { x: 0.4282, y: 0.5237 },
      sB: { x: 0.1995, y: 0.2199 },
  },
  dstPoint = { x: 0, y: 0 }) => {
  //固定
  // let srcArea = {
  //     sR: { x: 0.6400, y: 0.3300 },
  //     sG: { x: 0.3000, y: 0.6000 },
  //     sB: { x: 0.1500, y: 0.0600 },
  // }
  let srcArea = {
      sR: { x: 0.64843, y: 0.33086 },
      sG: { x: 0.32114, y: 0.59787 },
      sB: { x: 0.15588, y: 0.06604 },
  }
  // //能力表获取  
  // let dstArea = {
  //     sR: { x: 0.6491, y: 0.3470 },
  //     sG: { x: 0.4282, y: 0.5237 },
  //     sB: { x: 0.1995, y: 0.2199 },
  // }
  // let anchorPoint = { x: 0.34565, y: 0.35848 }
  let anchorPoint = { x: 0.34565416786629943, y: 0.3584833481090652 }
  let srcPoint = { x: cx, y: cy }
  return oppColorAreaConvert(srcArea, dstArea, anchorPoint, srcPoint, dstPoint)
}